import { create } from 'zustand';

const useSharedStateStore = create()((set) => ({
  playingResourceId: null,
  mediaTimestamp: null,
  pdfPage: null,
  setPlayingResourceId: (playingResourceId) => set({
    playingResourceId
  }),
  setMediaTimestamp: (timestamp) => set({
    mediaTimestamp: timestamp
  }),
  setPdfPage: (page) => set({
    pdfPage: page
  })
}));

export { useSharedStateStore };
//# sourceMappingURL=sharedState.js.map
